import { createSignal, Show } from 'solid-js'
import './Modal.css'
import { userStore } from '/web/store'
import LoginFormSocialButtons from './LoginFromSocialButtons'
import { CFLogo } from '/web/shared/aifans/Logo'

interface Props {
  onClickLogin?: any
  onClickRegister?: any
}

const ENABLE_SOCIAL_LOGIN = true

const RegisterFormModal = (props: Props) => {
  const user = userStore()

  const [showPassword, setShowPassword] = createSignal(false)

  return (
    <Show when={user.showLogin && !user.loginModalRedirect?.startsWith('/hentai')}>
      <div
        class="fixed inset-0 z-[200] flex items-center justify-center overflow-y-auto"
        style="background: rgba(0,0,0,0.90)"
        onClick={() => userStore.loginModal(false)}
      >
        <div
          class="relative w-full max-w-[420px] rounded-[18px] border border-[rgba(0,229,255,0.18)] px-[30px] pb-[26px] pt-8 max-h-[calc(100vh-40px)] overflow-y-auto"
          style="background: linear-gradient(to bottom, #14101f, #0c0916); box-shadow: 0 30px 80px rgba(138,43,226,0.28)"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={() => userStore.loginModal(false)}
            class="absolute top-[14px] right-[14px] w-8 h-8 rounded-full border border-[var(--cf-hairline)] grid place-items-center text-[22px] leading-none transition-all duration-200 hover:rotate-90"
            style="background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.55)"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,60,172,0.18)'
              e.currentTarget.style.color = 'white'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.05)'
              e.currentTarget.style.color = 'rgba(255,255,255,0.55)'
            }}
          >
            &#10005;
          </button>

          {/* Logo */}
          <div class="flex justify-center mb-[22px]">
            <CFLogo size="md" showSub />
          </div>

          {/* Title */}
          <div class="font-bebas text-[32px] tracking-[1.5px] text-center text-white leading-[1.1]">
            Create Account
          </div>
          <div class="font-rajdhani text-[13px] font-semibold tracking-[0.6px] text-center text-[var(--cf-muted)] mt-1 mb-[22px]">
            Join the CosplayFans community
          </div>

          {/* Google Sign Up */}
          <LoginFormSocialButtons show={ENABLE_SOCIAL_LOGIN} user={user} isRegister />

          <form onSubmit={props.onClickRegister}>
            <div class="flex flex-col gap-[14px]">
              <div>
                <label class="block font-rajdhani text-[10px] font-bold tracking-[1.4px] uppercase text-[rgba(255,255,255,0.55)] mb-[6px]">
                  Username
                </label>
                <input
                  name="username"
                  placeholder="Choose a username"
                  autocomplete="username"
                  class="w-full h-[44px] px-[14px] rounded-[10px] border border-[var(--cf-hairline)] text-white font-nunito text-[14px] outline-none transition-all duration-200 placeholder:text-[rgba(255,255,255,0.28)] focus:border-[rgba(0,229,255,0.5)] focus:bg-[rgba(0,229,255,0.04)] focus:shadow-[0_0_0_3px_rgba(0,229,255,0.12)]"
                  style="background: rgba(255,255,255,0.04)"
                />
              </div>
              <div>
                <label class="block font-rajdhani text-[10px] font-bold tracking-[1.4px] uppercase text-[rgba(255,255,255,0.55)] mb-[6px]">
                  Email
                </label>
                <input
                  name="email"
                  type="email"
                  placeholder="Enter your email address"
                  autocomplete="email"
                  class="w-full h-[44px] px-[14px] rounded-[10px] border border-[var(--cf-hairline)] text-white font-nunito text-[14px] outline-none transition-all duration-200 placeholder:text-[rgba(255,255,255,0.28)] focus:border-[rgba(0,229,255,0.5)] focus:bg-[rgba(0,229,255,0.04)] focus:shadow-[0_0_0_3px_rgba(0,229,255,0.12)]"
                  style="background: rgba(255,255,255,0.04)"
                />
              </div>
              <div>
                <label class="block font-rajdhani text-[10px] font-bold tracking-[1.4px] uppercase text-[rgba(255,255,255,0.55)] mb-[6px]">
                  Password
                </label>
                <div class="relative">
                  <input
                    name="password"
                    type={showPassword() ? 'text' : 'password'}
                    placeholder="Create a password"
                    autocomplete="new-password"
                    class="w-full h-[44px] px-[14px] rounded-[10px] border border-[var(--cf-hairline)] text-white font-nunito text-[14px] outline-none transition-all duration-200 placeholder:text-[rgba(255,255,255,0.28)] focus:border-[rgba(0,229,255,0.5)] focus:bg-[rgba(0,229,255,0.04)] focus:shadow-[0_0_0_3px_rgba(0,229,255,0.12)]"
                    style="background: rgba(255,255,255,0.04)"
                  />
                  <button
                    type="button"
                    class="absolute right-3.5 top-1/2 flex -translate-y-1/2 items-center border-none bg-transparent p-1 transition-colors cursor-pointer"
                    style="color: rgba(255,255,255,0.4)"
                    onClick={() => setShowPassword(!showPassword())}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <button
              type="submit"
              class="mt-[6px] w-full h-[48px] rounded-[12px] border-none text-white font-rajdhani font-extrabold text-[14px] tracking-[1px] uppercase cursor-pointer transition-all duration-200 hover:translate-y-[-2px]"
              style="background: var(--cf-grad-hot); box-shadow: 0 8px 24px rgba(138,43,226,0.35)"
            >
              Create Account
            </button>
          </form>

          <div class="mt-[18px] text-center font-rajdhani text-[13px] font-semibold text-[rgba(255,255,255,0.5)]">
            Already have an account?
            <a
              href="#"
              class="text-[var(--cf-cyan)] font-bold ml-1 cursor-pointer hover:underline"
              onClick={(e) => {
                e.preventDefault()
                props.onClickLogin?.()
              }}
            >
              Log In
            </a>
          </div>

          <div class="mt-3 text-center font-nunito text-[11px] leading-[1.5] text-[rgba(255,255,255,0.32)]">
            By creating an account you confirm you are 18+ and agree to our Terms & Privacy.
          </div>
        </div>
      </div>
    </Show>
  )
}

export default RegisterFormModal
